export default {
  valueType: 'table',
  FormItemProps: {
    valuePropName: "dataSource",
    style: {}
  },
  FooterProps: {
    ishidden: false,
    onClick: false,
  },
  ControlProps: {
    dataSource: [],
    columns: [{
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '年龄',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: '住址',
      dataIndex: 'address',
      key: 'address',
    }],
  },
};
